import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { HttpClient } from '@angular/common/http'
import { InfoDialogService, loadAccount } from '@tokeet/tv3-platform'
import { switchMap, tap } from 'rxjs/operators'
import { CloseAccountDialogComponent } from './close-account-dialog.component'
import { Store } from '@ngrx/store'
import { of } from 'rxjs'

export interface CloseAccountForm {
  reason: string
  channel_manager: string
  app: string
}

@Injectable()
export class CloseAccountDialogService {
  constructor(
    private dialog: MatDialog,
    private http: HttpClient,
    private infoDialog: InfoDialogService,
    private store: Store<any>
  ) {}

  open(data: { app: string; callScheduleUrl: string }) {
    const defaultConfig: MatDialogConfig = {
      width: '600px',
      height: 'auto',
      panelClass: ['fixed-modal'],
      data: { ...data },
    }
    return this.dialog.open(CloseAccountDialogComponent, defaultConfig)
  }

  closeAccount(payload: CloseAccountForm, immediate = false) {
    const url = `@api/account/close`
    return this.http.put(url, payload).pipe(
      tap(() => this.store.dispatch(loadAccount())),
      switchMap(() => {
        if (immediate) {
          return this.infoDialog.open({
            title: $localize`Subscription canceled`,
            body: $localize`Subscription is canceled, you can continue using the app until the end of billing cycle.`,
            closeText: 'OK',
          })
        } else {
          return this.infoDialog.open({
            title: $localize`Request received`,
            body: `Your request to cancel your account has been received.<br>One of our account specialists will be in touch to process your cancellation.`,
            closeText: 'OK',
          })
        }
      })
    )
  }
}
